import { render } from "./MiniSiteLinksResult.vue?vue&type=template&id=31d74b73&scoped=true"
import script from "./MiniSiteLinksResult.vue?vue&type=script&lang=js"
export * from "./MiniSiteLinksResult.vue?vue&type=script&lang=js"

import "./MiniSiteLinksResult.vue?vue&type=style&index=0&id=31d74b73&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d74b73"]])

export default __exports__